'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import classNames from 'classnames';
import GradeTypeConstants from '../constants/GradeTypeConstants';
import ScoreUtil from '../util/ScoreUtil';
import { jsx as _jsx } from "react/jsx-runtime";
export default class Score extends Component {
  constructor(...args) {
    super(...args);
    this.getScoreClassName = scorePercentage => {
      const gradeType = ScoreUtil.getOverallGradeType(scorePercentage);
      return classNames((gradeType === GradeTypeConstants.GREAT || gradeType === GradeTypeConstants.GOOD) && 'score-container-good', 'score-container', gradeType === GradeTypeConstants.OK && 'score-container-ok', gradeType === GradeTypeConstants.BAD && 'score-container-bad');
    };
  }
  render() {
    const {
      children,
      onClick,
      scorePercentage,
      scoreStyle
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      className: this.getScoreClassName(scorePercentage),
      onClick: onClick,
      style: scoreStyle,
      children: children
    });
  }
}
Score.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  scorePercentage: PropTypes.number.isRequired,
  scoreStyle: PropTypes.object
};